import api from "./api";

// Mantenimiento de los pagos de los periodos de terapia. Lo normal es un pago
// por periodo, pero se admiten casos excepcionales (varios pagos o referenciar
// un comprobante existente) y los pagos se pueden anular y volver a activar.
const terapiaPeriodoPagoService = {
    getsTerapiaPeriodoPagoView: async (filters) => {
        const response = await api.get("/TerapiaPeriodoPago/GetsTerapiaPeriodoPagoView", { params: filters });

        return response.data.data;
    },

    getsPagosDelPeriodo: async (idTerapiaPeriodo) => {
        const response = await api.get("/TerapiaPeriodoPago/GetsPagosDelPeriodo", { params: { idTerapiaPeriodo } });

        return response.data.data;
    },

    addTerapiaPeriodoPago: async (pago) => {
        const response = await api.post("/TerapiaPeriodoPago/AddTerapiaPeriodoPago", pago);

        return response.data.data;
    },

    deleteTerapiaPeriodoPago: async (idTerapiaPeriodo, numero) => {
        const response = await api.post("/TerapiaPeriodoPago/DeleteTerapiaPeriodoPago", null, {
            params: { idTerapiaPeriodo, numero },
        });

        return response.data.data;
    },

    anularTerapiaPeriodoPago: async (idTerapiaPeriodo, numero) => {
        const response = await api.post("/TerapiaPeriodoPago/AnularTerapiaPeriodoPago", null, {
            params: { idTerapiaPeriodo, numero },
        });

        return response.data.data;
    },

    activarTerapiaPeriodoPago: async (idTerapiaPeriodo, numero) => {
        const response = await api.post("/TerapiaPeriodoPago/ActivarTerapiaPeriodoPago", null, {
            params: { idTerapiaPeriodo, numero },
        });

        return response.data.data;
    },
};

export default terapiaPeriodoPagoService;
